import {
  FETCH_VENTAS_REQUEST,
  FETCH_VENTAS_SUCCESS,
  FETCH_VENTAS_FAILURE,
} from "../actions/ventas/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VENTAS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_VENTAS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_VENTAS_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
